import axios from 'axios';

const language = document.querySelector('html').getAttribute('lang');

const instance = axios.create({
    headers: { 'Accept-Language': language },
});

export default instance;
